import React from 'react';
import Toast from '../../style/components/toastMessage';
import { Button, Label } from '../../style';

interface DataParams {
	openToast: boolean;
	messageType: string;
	closeToast: () => void;
}

const ToastMessage: React.FC<DataParams> = (props: any) => {
	const { openToast = false, closeToast, messageType = 'Success', children } = props;

	return (
		<Toast iconToast toastBorder show={openToast} messageType={messageType} right="20px" top="20px">
			<Label> {children}</Label>
			<Button iconShow type="button" onClick={closeToast} style={{ fontSize: '15px' }}>
				X
			</Button>
		</Toast>
	);
};

export default ToastMessage;
